<template>
  <div class="content">
    <!-- 视频 -->
    <div class="video-block" v-if="analysisVideo && Object.keys(analysisVideo).length > 0">
      <video :src="analysisVideo && analysisVideo.url" controls class="video"></video>
    </div>
    <div class="assets" v-else>
      <van-swipe class="my-swipe" v-if="files.length > 0" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in files" :key="item.id">
          <img :src="item && item.url" class="img" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="all">
      <div class="user_info">
        <div class="img_box">
          <img class="img" :src="iepUserDTO && iepUserDTO.headPicUrl" alt="" />
        </div>
        <div class="info">
          <div class="data">
            <div class="user_type">
              {{ iepUserDTO && iepUserDTO.realName }}
              <div class="time">{{ detailData && detailData.times }}</div>
            </div>
          </div>
        </div>
      </div>
      <p class="title">{{ detailData && detailData.title }}</p>
      <div class="doc_content" v-html="detailData.content"></div>
    </div>
    <div class="file-div" :class="workType === 'correct' ? 'correct' : ''">
      <div class="div-label">文件</div>
      <div class="div-con" v-if="filePdf && Object.keys(filePdf).length > 0" @click="handleClick">
        {{ `${filePdf.title}.${filePdf.format}` }}
        <img v-if="isTutorAndPeSign" src="@/assets/images/zone/img45.png" class="icon-upload" @click.stop="handleDownLoad(filePdf)" alt="">
      </div>
      <div class="div-con" v-else>暂未上传</div>
    </div>
    <div class="work-txtarea" v-if="workType === 'correct'">
      <div class="tip">导师评语</div>
      <van-field v-model="message" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入评语" />
    </div>
    <div class="work-txtarea" v-else-if="detailData.approvalWorkTime">
      <div class="tip">导师评语</div>
      <van-field :value="detailData && detailData.approvalWorkNote" disabled rows="3" autosize type="textarea" maxlength="100" placeholder="请输入评语" />
    </div>
    <div class="work-txtarea work-txtarea2" v-if="detailData.approvalWorkTime > 0">
      <div class="tip">评语导师：</div>
      <div class="txts">{{ detailData.tuTorInfoDTO && Object.keys(detailData.tuTorInfoDTO).length > 0 ? detailData.tuTorInfoDTO.realName : iepUserDTO.realName }}</div>
    </div>
    <template v-if="`${zoneRoles.peSign}` !== '1' && `${userInfo.memberType}` !== '1'">
      <div class="submit-btn isCorrected" v-if="workType === 'correct' && detailData.approvalWorkNote">已提交评语</div>
      <div class="submit-btn isCorrect" v-else-if="workType === 'correct'" @click="handleCorrectWork">提交评语</div>
      <template v-if="detailData.areaPostbarInfoDTO && `${detailData.areaPostbarInfoDTO.isCutTime}` === '1'">
        <div class="submit-btn isComment" v-if="workType === 'answer' && !detailData.approvalWorkTime">已提交</div>
        <div class="submit-btn edit" v-if="workType === 'answer' && !detailData.approvalWorkTime" @click="handleGo">编辑内容</div>
      </template>
    </template>
    <returnBack></returnBack>
  </div>
</template>

<script>
import { workDetails, correctWork } from '@/api/zone'
import { allVideo, roleIsConsumer, rolesClick } from './data'
import returnBack from './compontents/returnBack.vue'
import axios from 'axios'
export default {
  components: {
    returnBack
  },
  data () {
    return {
      detailData: {},
      iepUserDTO: {},
      files: [],
      analysisVideo: {},
      isPlayVideo: true,
      filePdf: {},
      workType: '',
      message: '',
      zoneRoles: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    isTutorAndPeSign () {
      return !(`${this.zoneRoles.peSign}` !== '1' && `${this.zoneRoles.tutorSign}` !== '1' && `${this.userInfo.memberType}` !== '1')
    },
  },
  mounted () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    this.zoneRoles = role
    if (this.$route.query.workType === 'correct') {
      if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo)) {
        this.$router.push({
          path: `/zoneDetails?areaId=${this.$route.query.areaId}`
        })
        return
      }
    }
    this.workType = this.$route.query.workType
    this.handleFun()
  },
  methods: {
    handleGetRoles(areaId) {
      // roleDetails({
      //   areaId,
      //   userId: this.userInfo.id
      // }).then(res => {
      //   this.zoneRoles = res.data
      // })
      this.zoneRoles = JSON.parse(sessionStorage.getItem('roleResult'))
    },
    async handleClick12(file) {
      try {
        const response = await axios({
          url: file.url,
          method: 'GET',
          responseType: 'blob', // 必须指定为blob类型才能下载
        })
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = file.url
        link.setAttribute('download', `${file.title}.${file.format}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url) // 清理内存中的对象URL
      } catch (error) {
        console.error('下载PDF时发生错误:', error)
      }
    },
    handleClick () {
      const curFileSize = parseFloat(this.filePdf.size.replace(/[^.\d]/g, ''))
      const curFileFormat = this.filePdf.size.substring(this.filePdf.size.length - 2, this.filePdf.size.length)
      if (curFileSize > 50 && curFileFormat === 'MB') {
        this.handleClick12(this.filePdf)
      } else {
        if (this.filePdf.url.indexOf('pdf') > -1) {
          this.$router.push({
            path: `/pdfView?pdfUrl=${this.filePdf.url}&areaId=${this.$route.query.areaId}`
          })
        } else {
          this.$router.push({
            path: `/pptView?pptSrc=${this.filePdf.url}&areaId=${this.$route.query.areaId}`
          })
        }
      }
    },
    handleFun () {
      let workId = this.$route.query.workId
      workDetails({ workId: workId }).then(res => {
        this.detailData = res.data
        this.iepUserDTO = this.detailData.iepUserInfoDTO
        this.detailData.times = this.$moment(this.detailData.createTime * 1).format('MM-DD HH:mm')
        if (res.data.approvalWorkNote) {
          this.message = res.data.approvalWorkNote
        }
        this.files = res.data.files.filter(item => {
          if (item.format === 'pdf' || item.format.indexOf('ppt') > -1) {
            this.filePdf = item
          }
          return item.id !== this.filePdf.id
        })
        if (this.files.length === 1 && allVideo.indexOf((this.files[0].format).toLocaleLowerCase()) > -1) {
          this.analysisVideo = this.files[0]
        }
        this.handleGetRoles(res.data.areaPostbarInfoDTO.areaId)
      })
    },
    handleClickItemsVideo () {
      this.isPlayVideo = !this.isPlayVideo
      setTimeout(() => {
        let videos = this.$refs.video
        videos.player.play()
      })
    },
    handleGo () {
      this.$router.push({
        path: `/answerWork?postId=${this.detailData.postbarId}&workId=${this.$route.query.workId}&areaId=${this.zoneRoles.areaId}`
      })
    },
    handleCorrectWork () {
      if (!this.message) {
        this.$toast('请填写评语！')
        return
      }
      let params = {
        workId: this.$route.query.workId,
        approvalWorkNote: this.message
      }
      correctWork(params).then(res => {
        this.$toast('提交成功')
        // this.handleFun()
        setTimeout(() => {
          this.$router.back()
        }, 500)
      })
    },
    handleDownLoad(file) {
      const url = window.URL.createObjectURL(new Blob([file.url]))
      const link = document.createElement('a')
      link.href = url
      let fileName = file.title || 'default_name' // 提供一个默认值以防止 file.title 为 undefined
      let fileFormat = file.format || 'txt' // 提供一个默认值以防止 file.format 为 undefined
      let encodedFileName = `${encodeURIComponent(fileName)}.${fileFormat}`
      link.setAttribute('download', encodedFileName) // 或者根据实际情况获取文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 0 50px;
  box-sizing: border-box;
  padding-bottom: 200px;

  .all {
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 60px;
    padding-top: 16px;
  }

  .title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 18px;
    color: #282828;
    margin-bottom: 20px;
  }

  .user_info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .img_box {
      width: 32px;
      height: 32px;
      margin-right: 4px;
      transform: translateY(-1px);

      .img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }

    .info {
      .name {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
      }

      .data {
        .user_type {
          display: flex;
          align-items: center;

          .img1 {
            width: 39px;
            height: 13px;
          }

          .img2 {
            width: 29px;
            height: 13px;
          }
        }

        .time {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 12px;
          color: #7a8494;
          margin-left: 6px;
        }
      }
    }
  }

  .doc_content {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 30px;
  }
}
.my-swipe .van-swipe-item {
  .img {
    width: 100%;
    height: 205px;
    object-fit: contain;
  }
}

.video-block {
  width: 100%;
  height: 200px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .video {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
}

.file-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  font-size: 14px;
  color: #343434;
  // position: fixed;
  // bottom: 150px;
  // left: 14px;
  margin-left: 14px;
  width: calc(100% - 28px);
  background-color: #fff;
  z-index: 9;

  &.correct {
    bottom: 0;
    position: relative;
  }

  .div-con {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .icon-upload {
      width: 18px;
      height: 18px;
      display: block;
      margin-left: 20px;
    }
  }
}

.work-txtarea {
  margin: 0 14px;
  &.work-txtarea2 {
    display: flex;
    align-items: center;
  }
  .tip, .txts {
    font-size: 16px;
    color: #202020;
    font-weight: bold;
    line-height: 20px;
    padding-top: 16px;
    margin-bottom: 8px;
  }

  /deep/.van-field {
    padding-left: 0;
    padding-right: 0;
  }
}

.submit-btn {
  background: #EB1700;
  box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
  border-radius: 100px;
  width: 343px;
  height: 42px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 42px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;

  &.isComment {
    background: #EBEBEB;
    color: #7A8494;
    box-shadow: none;
    bottom: 90px;
  }

  &.isCorrect {
    bottom: 40px;
  }

  &.isCorrected {
    background: #EBEBEB;
    box-shadow: none;
    color: #7A8494;
  }

  &.edit {
    color: #7A8494;
    background: transparent;
    bottom: 40px;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/workDetails copy.vue